import { trackPromise } from 'react-promise-tracker';
import http from "../http-common";

class TrabajadorHistoricoService {

    create(data) {
        return http.post("/trabajadorhistorico",data);
    }

    buscarPorRut(rut) {
        return http.get(`/trabajadorhistorico/${rut}`);
    }

    updateTrabajador(id, data) {
        return http.put(`/trabajadorhistorico/${id}`, data);
    }
    
    getAll() {
        return trackPromise(
            http.get("/trabajadorhistorico"),"tgetall"
        );
        
    }

    getByID(id) {
        return http.get(`/trabajadorhistorico/id/${id}`);
    }

    getByUser(id_usuario) {
        return trackPromise(
            http.get(`/trabajadorhistorico/user/${id_usuario}`),"tgetuser"
        );
    }

    getByEstado(estado) {
        return http.get(`/trabajadorhistorico/estado/${estado}`);
    }

    async getAll2() {
        const {data} = await http.get("/trabajadorhistorico");
        console.log("Data", data);
        return data;
    }

    getAcreditador() {
        return http.get('/trabajadorhistorico/acreditador/all');
    }

    getTodos() {
        return http.get("/trabajadorhistorico/todos/todos");
    }
}

export default new TrabajadorHistoricoService();